import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import UnidadeDeAprendizagem from 'Interface/UnidadesDeAprendizagem';

interface Aula {
  urlAula: string;
  urlLivro?: string;
  unidadeDeAprendizagem?: UnidadeDeAprendizagem;
}

const inicial: Aula = {
  urlAula: '',
};

export const aula = createSlice({
  name: 'aula',
  initialState: inicial,
  reducers: {
    salvar: (estado, acao: PayloadAction<Aula>) =>
      (estado = { ...estado, ...acao.payload }),
  },
});

export const { salvar } = aula.actions;

export default aula.reducer;
